'use strict';

/**
 *
 * @name: brandStories
 *
 */

import DirectiveTemplate from './nn-brand-stories.directive.html';

function BrandStoriesDirective(
  $translate,
  $stateParams,
  apiPostService,
  transObject,
  brandAnalytics
) {

  'ngInject';

  return {
    restrict: 'A',
    template: DirectiveTemplate,
    scope: {
      content: '&',
      loaded: '='
    },
    link: function(scope, $element) {

      scope.currentPage = 1;
      scope.item = scope.content();
      scope.posts = [];
      scope.brandAnalytics = brandAnalytics;
      scope.brandName = $stateParams.displayName;

      scope.translations = {
        loadMore: $translate.instant('LOAD_MORE'),
        addToPlaylist: $translate.instant('ADD_TO_PLAYLIST'),
        addToQueue: $translate.instant('ADD_TO_QUEUE'),
        removeFromQueue: $translate.instant('REMOVE_FROM_QUEUE'),
        play: $translate.instant('PLAY'),
        stories: $translate.instant('STORIES')
      };

      if (!scope.item.jsonData || !scope.item.jsonData.sources[0] || !scope.item.jsonData.sources[0].userId) {

        return terminate();
      }

      scope.getPosts = function(page) {

        scope.currentPage = page;

        apiPostService
          .getPost(null, 'publishDate desc', page, 7, null, null, true, null, scope.item.jsonData.sources[0].userId)
          .then(function(res) {
            console.log(12333)
            var posts = res.data.items;

            posts.forEach(function(post) {

              transObject.translate(post);
              transObject.trueSlug(post);
              transObject.getDuration(post);
              transObject.setBookmark(post);
              scope.posts.push(post);
            });

            scope.postsSize = scope.posts.length;
            scope.showLoadMoreBtn = res.data.meta.totalPages > page;
          });
      };

      scope.getPosts(scope.currentPage);

      scope.resolveImageUrl = function(index, post) {

        if (index === 0) {

          return post.imageUrl;
        }

        if (index === 1 && scope.postsSize === 2) {

          return post.imageUrl;
        }

        return post.thumbnailUrl;
      };

      /* private */

      function terminate() {

        scope.$destroy();
        $element.find('*').remove();
        $element.remove();
      }
    }
  };
}

export default BrandStoriesDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-brand-stories/nn-brand-stories.directive.js